import { assert, getRandomUID } from "../../shared/Utils.js";
const noopExecutor = () => { };
export class EsTaskPromise extends Promise {
    taskUID = getRandomUID();
    resolve;
    reject;
    constructor(executor = noopExecutor) {
        let localResolve;
        let localReject;
        super((resolve, reject) => {
            localResolve = resolve;
            localReject = reject;
            executor(resolve, reject);
        });
        assert(localResolve && localReject);
        this.resolve = localResolve;
        this.reject = localReject;
    }
}
